import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import Badge from 'react-bootstrap/lib/Badge';
import AriAvatar from 'containers/Ari/AriAvatar';
import { trackEvent } from 'helpers/Analytics';
import styles from './AriUpsell.module.scss';

const AriUpsellHeader = ({ isLoggedIn }) => (
  <>
    <div className={styles.headerRow}>
      <AriAvatar size={36} className={styles.avatar} />
      <p className={styles.upsellTitle}>
        Ari: your job agent
        {isLoggedIn && (
          <Badge
            className={styles.newBadge}
            style={{ backgroundColor: '#0777DA' }}
          >
            New
          </Badge>
        )}
      </p>
    </div>
    <p>
      Ari searches hundreds of sources for you, every hour, including company
      careers pages: more than 10 million postings a month.
    </p>
  </>
);

AriUpsellHeader.propTypes = {
  isLoggedIn: PropTypes.bool.isRequired,
};

const AskAriButton = ({ isLoggedIn, onClick }) => (
  <Button
    href={isLoggedIn ? '/ari' : '/freelance/ari'}
    className={styles.upsellButton}
    bsStyle="primary"
    onClick={onClick}
  >
    {isLoggedIn ? 'Ask Ari to search' : 'Meet Ari'}
  </Button>
);

AskAriButton.propTypes = {
  isLoggedIn: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

const LearnMoreButton = ({ onClick }) => (
  <Button
    href="/freelance/ari"
    className={`${styles.upsellButton} ${styles.learnMoreButton}`}
    bsStyle="default"
    onClick={onClick}
  >
    Learn more
  </Button>
);

LearnMoreButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

const AriUpsellActions = ({
  isLoggedIn,
  compactButtons,
  onAskClick,
  onLearnMoreClick,
}) => (
  <div
    className={`${styles.buttonRow} ${
      compactButtons ? styles.buttonRowCompact : styles.buttonRowFull
    }`}
  >
    <AskAriButton isLoggedIn={isLoggedIn} onClick={onAskClick} />
    <LearnMoreButton onClick={onLearnMoreClick} />
  </div>
);

AriUpsellActions.propTypes = {
  isLoggedIn: PropTypes.bool.isRequired,
  compactButtons: PropTypes.bool.isRequired,
  onAskClick: PropTypes.func.isRequired,
  onLearnMoreClick: PropTypes.func.isRequired,
};

const getVisibilityClass = (alwaysShow, mobile) => {
  if (alwaysShow) return '';
  return mobile ? styles.upsellMobile : styles.upsellDesktop;
};

const AriUpsell = ({ user, mobile, alwaysShow, compactButtons }) => {
  const isLoggedIn = !!user;
  const onAskClick = () => trackEvent('ari-sidebar-clicked');
  const onLearnMoreClick = () => trackEvent('ari-sidebar-learn-more-clicked');
  const visibility = getVisibilityClass(alwaysShow, mobile);
  const className = `${styles.upsellContainer} ${visibility}`.trim();

  return (
    <div className={className}>
      <AriUpsellHeader isLoggedIn={isLoggedIn} />
      <AriUpsellActions
        isLoggedIn={isLoggedIn}
        compactButtons={compactButtons}
        onAskClick={onAskClick}
        onLearnMoreClick={onLearnMoreClick}
      />
    </div>
  );
};

AriUpsell.propTypes = {
  user: PropTypes.object,
  mobile: PropTypes.bool,
  alwaysShow: PropTypes.bool,
  compactButtons: PropTypes.bool,
};

AriUpsell.defaultProps = {
  mobile: false,
  alwaysShow: false,
  compactButtons: false,
};

export default AriUpsell;
